import { parseBookingDate } from '@/utils/bookingDate';

export const CANCELED_VISIT_STATUSES = ['canceled', 'payment_canceled'];

export function isCanceledVisitStatus(status) {
  return CANCELED_VISIT_STATUSES.includes(status);
}

// Czy termin wizyty juz minal (na podstawie zapisanego terminu / danych z Medfile).
export function isPastBooking(booking) {
  const start = parseBookingDate(booking?.output?.visit?.start || booking?.chosenDate);
  return !!start && start.getTime() < Date.now();
}

/**
 * Wyliczany status wizyty na potrzeby widoku "Twoje wizyty".
 *
 * Uwaga: po udanej przedplacie PayU wizyta konczy w DB jako 'registered'
 * (rejestracja w Medfile), a fakt oplacenia niesie payment_status == 'completed'.
 * Dlatego "paid" (Oplacona) rozpoznajemy po platnosci, a nie po kolumnie status.
 * Blad rejestracji ma pierwszenstwo - moze wystapic mimo oplacenia.
 *
 * Potwierdzona wizyta (oplacona lub umowiona) po terminie => 'completed'.
 */
export function deriveVisitStatus(booking) {
  if (!booking) return 'pending_payment';

  const raw = booking.visitStatus
    || (booking.status === 'pending_payment' ? 'pending_payment' : null)
    || (booking.status === 'success' ? 'registered' : null)
    || (booking.status === 'canceled' ? 'canceled' : null)
    || (booking.status === 'error' ? 'failed' : null)
    || 'pending_payment';
  const paymentStatus = booking.payment?.status;

  let resolved;
  if (raw === 'failed') {
    resolved = 'failed';
  } else if (raw === 'payment_canceled') {
    resolved = 'payment_canceled';
  } else if (raw === 'canceled') {
    resolved = 'canceled';
  } else if (paymentStatus === 'completed' || raw === 'paid') {
    resolved = 'paid';
  } else if (raw === 'registered') {
    resolved = 'registered';
  } else {
    resolved = 'pending_payment';
  }

  if ((resolved === 'paid' || resolved === 'registered') && isPastBooking(booking)) {
    return 'completed';
  }
  return resolved;
}

// Statusy liczone na plakietce przycisku "Twoje wizyty" w headerze:
// oplacone, umowione oraz oczekujace na platnosc (bez zakonczonych/bledych/anulowanych).
const HEADER_COUNTED_STATUSES = ['paid', 'registered', 'pending_payment'];

export function countHeaderVisits(bookings) {
  return (bookings || []).filter(
    (booking) => HEADER_COUNTED_STATUSES.includes(deriveVisitStatus(booking)),
  ).length;
}
